export default "__VITE_ASSET__c54d6fa0__"